const jsonRpc = require('./jsonRpc.js')
const widgetApiInterface = require('./widgetApi')
import mocks from './mocks'


const api = new jsonRpc(process.env.VUE_APP_URL+'v'+process.env.VUE_WIDGET_VERSION+'/api', widgetApiInterface, mocks)

export default api